// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3VM7C","rootCenter":"LoadMoreObserver_rootCenter__1Cc8M","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1pCC3"};